import { render } from "./BarGraphView.vue?vue&type=template&id=32c70a27"
import script from "./BarGraphView.vue?vue&type=script&lang=js"
export * from "./BarGraphView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__